import { get } from '../utils/httpClient'
import { GetVouchersResponse } from './types'
import { getRedDataApiPaths } from '../config'

export const apiGetAllVouchers = async (limit: number, offset: number) => {
  const response = (await get(`${getRedDataApiPaths().RED_API_VOUCHERS}?offset=${offset}&limit=${limit}`, true)) as GetVouchersResponse
  return response
}
